module.exports = __webpack_public_path__ + "img/ground1.0428fd21.jpg";